import { MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule } from "@ngx-translate/core";
import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { OrcadentQuestionnaireSection } from "libs/questionaire/src/lib/orcadent/models";

@Component({
	selector: 'orcadent-help-dialog',
	templateUrl: 'orcadent-help-dialog.component.html',
	standalone: true,
	imports: [MatDialogModule, MatButtonModule, TranslateModule],
	changeDetection: ChangeDetectionStrategy.OnPush,
  })
  export class OrcadentHelpDialogComponent {
	data: {
		section: OrcadentQuestionnaireSection
		headline: string,
		content: string,
	} = inject(MAT_DIALOG_DATA);

	section: OrcadentQuestionnaireSection;
  }

